import Utils from "./Utils";

export default class IntroHints {
  constructor(container, translations) {
    this.container = container;
    this.isSmallScreen = Utils.isSmallOrMediumLayout();
    this.isLandscape = Utils.isLandscapeMobile();
    this.highligtedElement = null;
    this.content = container.querySelector(".content");

    //size
    const canvases = document.querySelector(".drawing-content");
    const height = canvases.getBoundingClientRect().height;
    //this.container.style.height = `${(window.innerHeight - height) / 2}px`;

    this.messages = {
      step1: translations.tutorial_step1,
      step2: translations.tutorial_step2,
      step3: translations.tutorial_step3,
      step4: translations.tutorial_step4,
      step5: translations.tutorial_step5,
      step6: translations.tutorial_step6,
    };

    this.buttons = {
      step1: document.querySelector("li.magic"),
      step2: document.querySelector("li.pen"),
      step4: document.querySelector("li.color"),
    }
    this.setText('step1');
    //this.content.innerText = this.messages["step1"];
  }

  onResize(dimensions) {
    //size
    const canvases = document.querySelector("#imageSource");
    const height = canvases.getBoundingClientRect().height;
    this.container.style.height = `${(window.innerHeight - height) / 2}px`;
  }

  demo() {
    this.container.style.display = "flex";
    setTimeout(() => {
      this.container.classList.remove("hide");
    }, 500);
  }

  hintReset() {
    this.container.classList.add("hide");
    setTimeout(() => {
      this.container.style.display = "none";
    }, 500);
  }

  show(step, direction = "right", time = 500) {
    this.container.style.display = "flex";
    this.container.classList.remove("hide");
    this.setText(step);
  }

  setText(step) {
    if (this.buttons[step]) {
      this.buttons[step].classList.remove("invisible");
    }
    this.content.style.opacity = 0;
    setTimeout(() => {
      this.content.innerText = this.messages[step];
      this.content.style.opacity = 1;
    }, 500);
  }

  hide() {
    this.container.classList.add("hide");
    setTimeout(() => {
      this.container.style.display = "none";
    }, 500);
  }

  // onMouseDown(e) {
  //   document.removeEventListener("mousedown", this.handler.mouseDown);
  //   this.hintReset();
  //   // set pointer events to none
  //   this.container.style.pointerEvents = "none";
  // }

  addArrow() {
    this.container.classList.add("arrow");
  }

  setOpacity(value) {
    this.container.style.opacity = value;
  }

  removeArrow() {
    this.container.classList.remove("arrow");
  }

  setArrowDown() {
    this.container.classList.add("down");
    this.container.classList.remove("up");
    this.container.classList.remove("left");
  }

  setArrowLeft() {
    this.container.classList.add("left");
    this.container.classList.remove("up");
    this.container.classList.remove("down");
  }

  setArrowUp() {
    this.container.classList.add("up");
    this.container.classList.remove("down");
    this.container.classList.remove("left");
  }

  moveTo(element, direction = "top", offsetY=0) {
    // mobile version
    let elemPosition = element.getBoundingClientRect();
    if (element.style.display == "none") {
      element.style.display = "block";
      elemPosition = element.getBoundingClientRect();
      element.style.display = "none";
    }

    if (this.isSmallScreen && !this.isLandscape) {
      // add an arrow to the tooltip
      this.addArrow();
      this.setArrowDown();
      this.container.style.position = "absolute";
      this.container.style.bottom = "auto";
      this.container.style.zIndex = "10";
      // we rest to 0 before we measure the container
      // otherwise this causes bugs (!)
      this.container.style.left = "0px";
      const containerWidth =
        this.container.querySelector(".hint-wrapper").clientWidth;
      // then, we do the calculation
      const val =
        elemPosition.left - containerWidth / 2 + elemPosition.width / 2;
      this.container.style.left = `${Math.max(10, val)}px`;
      if (val < 10) {
        document.documentElement.style.setProperty(
          "--arrow_left",
          Math.abs(val - 10 - 4) + "px"
        );
      } else {
        document.documentElement.style.setProperty("--arrow_left", "4px");
      }

      // for colorize: display tooltip at bottom
      if (direction === "bottom") {
        //this.setArrowLeft();
        this.setArrowUp();
        this.container.style.alignItems = "flex-start";
        this.container.style.top = `${
          elemPosition.top + elemPosition.height + offsetY
        }px`;
      }
      // else : display tooltip on top
      else {
        //this.setArrowLeft();
        this.container.style.top = `${
          elemPosition.top - elemPosition.height - 12
        }px`;
      }
    }
    // desktop version
    else {
      // if it's the colorize hint, display it centered and with an arrow.
      this.container.style.position = "absolute";
      this.container.style.bottom = "auto";
      this.container.style.zIndex = "10";
      this.container.style.left = `${
        elemPosition.left + elemPosition.width + 16
      }px`;
      this.container.style.top = `${elemPosition.top}px`;
    }
    this.highligtedElement = element;
  }
}
